
import { defineComponent } from 'vue'

// newstype information
interface NewsTypeInfo {
  [type: string]: {
    text: string
  }
}

// news information
interface NewsInfo {
  date: string,
  type: string,
  text: string
}

export default defineComponent({
  data () {
    return {
      newstype: {
        cv: { text: '[略歴]' },
        publication: { text: '[出版物]' },
        presentation: { text: '[発表・講演]' },
        note: { text: '[ノート]' },
        etc: { text: '' }
      } as NewsTypeInfo,
      news: [
        {
          date: '2026年1月27日',
          type: 'publication',
          text: 'スムーズな結晶界面におけるフォノン分布関数の境界条件および界面角運動量輸送に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2601.18584" target="_blank">arXiv:2601.18584</a>)．'
        },
        {
          date: '2025年12月24日',
          type: 'presentation',
          text: '新規超伝導体を舞台とする超伝導科学のフロンティアにおいて口頭発表を行いました．'
        },
        {
          date: '2025年10月24日',
          type: 'cv',
          text: '日本物理学会 <a href="http://www.r8.div.jps.or.jp/past_young_scientist_award.html" target="_blank">若手奨励賞(領域8)</a>を受賞しました．'
        },
        {
          date: '2025年10月15日',
          type: 'publication',
          text: '交替磁性に誘起される位相変調超伝導に関する研究がPhys. Rev. Bで<a href="https://link.aps.org/doi/10.1103/3k12-2467" target="_blank">出版</a>されました．'
        },
        {
          date: '2025年9月29日',
          type: 'presentation',
          text: 'The 16th International Symposium on Crystalline Organic Metals, Superconductors and Magnetsにおいて口頭発表を行いました．'
        },
        {
          date: '2025年9月16日',
          type: 'presentation',
          text: '日本物理学会 第80回年次大会において口頭発表を行いました．'
        },
        {
          date: '2025年9月16日',
          type: 'publication',
          text: 'カイラリティに依存する金属中のスピン分極に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2408.04450" target="_blank">arXiv:2408.04450</a>)．'
        },
        {
          date: '2025年8月8日',
          type: 'presentation',
          text: 'The 30th International Conference on Low Temperature Physicsにおいてポスター発表を行いました．'
        },
        {
          date: '2025年7月25日',
          type: 'publication',
          text: 'JSPJ News and Commentsにて短い<a href="https://journals.jps.jp/doi/10.7566/JPSJNC.22.08" target="_blank">解説記事</a>が公開されました．'
        },
        {
          date: '2025年7月8日',
          type: 'presentation',
          text: 'Conference on Strongly Correlated Electron Systems 2025において口頭発表を行いました．'
        },
        {
          date: '2025年6月30日',
          type: 'note',
          text: 'プレプリントの公開に伴い，研究で使用した<a href="https://github.com/shuntarosumita/altermagnet_SC" target="_blank">プログラム</a>および関連する<a href="/notes/GL_microscopic_derivation_real.pdf" target="_blank">ノート</a>を公開しました．'
        },
        {
          date: '2025年6月30日',
          type: 'publication',
          text: '交替磁性に誘起される位相変調超伝導に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2506.22297" target="_blank">arXiv:2506.22297</a>)．'
        },
        {
          date: '2025年6月18日',
          type: 'presentation',
          text: 'International Workshop on Chirality in Condensed Matter Physicsにおいてポスター発表を行いました．'
        },
        {
          date: '2025年4月1日',
          type: 'cv',
          text: '学術変革(A)「キメラ準粒子」による公募研究課題を始めました．研究期間は2027年3月末までです．'
        },
        {
          date: '2025年3月18日',
          type: 'presentation',
          text: '日本物理学会2025年春季大会において口頭発表を行いました．'
        },
        {
          date: '2025年3月14日',
          type: 'presentation',
          text: 'The 23rd Korea-Taiwan-Japan Symposium on Strongly Correlated Electron Systemにおいてポスター発表を行いました．'
        },
        {
          date: '2025年2月17日',
          type: 'presentation',
          text: 'Workshop on theory of cross correlations, multipoles, and computational material designにおいてポスター発表を行いました．'
        },
        {
          date: '2024年12月19日',
          type: 'presentation',
          text: '超伝導研究の新潮流において口頭発表を行いました．'
        },
        {
          date: '2024年11月15日',
          type: 'publication',
          text: '理想的なスピンレスDirac半金属群<i>RE</i><sub>8</sub>Co<i>X</i><sub>3</sub>に関する論文がCommun. Mater.で<a href="https://doi.org/10.1038/s43246-024-00635-9" target="_blank">出版</a>されました．'
        },
        {
          date: '2024年11月9日',
          type: 'publication',
          text: 'スピン軌道相互作用によって実現する非自明なStoner磁性に関する論文がProc. Natl. Acad. Sci.で<a href="https://www.pnas.org/doi/10.1073/pnas.2411038121" target="_blank">出版</a>されました．'
        },
        {
          date: '2024年9月21日',
          type: 'presentation',
          text: '<a href="https://asymmetry.hiroshima-u.ac.jp/event/1097" target="_blank">アシンメトリ量子若手秋の学校</a>において講演を行いました．'
        },
        {
          date: '2024年9月19日',
          type: 'presentation',
          text: '日本物理学会 第79回年次大会において口頭発表を行いました．'
        },
        {
          date: '2024年9月16日',
          type: 'publication',
          text: '結晶界面におけるフォノン角運動量輸送に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2409.08874" target="_blank">arXiv:2409.08874</a>)．'
        },
        {
          date: '2024年9月9日',
          type: 'presentation',
          text: '核子系と電子系における対相関と対凝縮相 において口頭発表を行いました．'
        },
        {
          date: '2024年9月7日',
          type: 'publication',
          text: '異方性に誘起されるスピンパリティ効果に関する論文がPhys. Rev. Bで<a href="https://journals.aps.org/prb/abstract/10.1103/PhysRevB.110.L100403" target="_blank">出版</a>されました．'
        },
        {
          date: '2024年7月2日',
          type: 'presentation',
          text: '<a href="https://www.icm2024.org/" target="_blank">The 22nd International Conference on Magnetism</a>においてポスター発表を行いました．'
        },
        {
          date: '2024年6月18日',
          type: 'presentation',
          text: '<a href="https://events.unifr.ch/ttqm2024/" target="_blank">Trends in the Theory of Quantum Materials 2024</a>においてポスター発表を行いました．'
        },
        {
          date: '2024年5月30日',
          type: 'presentation',
          text: '創発量子現象のフロンティア：超伝導接合，エッジ伝導，エニオン においてポスター発表を行いました．'
        },
        {
          date: '2024年5月14日',
          type: 'cv',
          text: '<a href="https://www.integrated.c.u-tokyo.ac.jp/introduction/scienceclub-2/" target="_blank">駒場サイエンス倶楽部</a>にて，「超伝導を結晶の『形』で分類する 〜物性物理と数理〜」というタイトルで学部1, 2年生向けのセミナーを行いました．'
        },
        {
          date: '2024年3月19日',
          type: 'presentation',
          text: '日本物理学会2024年春季大会において口頭発表を2件行いました．'
        },
        {
          date: '2024年3月8日',
          type: 'presentation',
          text: 'APS March Meeting 2024において口頭発表を行いました．'
        },
        {
          date: '2024年3月1日',
          type: 'publication',
          text: '異方性に誘起されるスピンパリティ効果に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2402.19311" target="_blank">arXiv:2402.19311</a>)．'
        },
        {
          date: '2024年1月26日',
          type: 'publication',
          text: '理想的なスピンレスDirac半金属群<i>RE</i><sub>8</sub>Co<i>X</i><sub>3</sub>に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2401.13930" target="_blank">arXiv:2401.13930</a>)．'
        },
        {
          date: '2024年1月5日',
          type: 'presentation',
          text: 'アシンメトリ量子物質の開発 〜現状と展望〜 においてポスター発表を行いました．'
        },
        {
          date: '2023年12月22日',
          type: 'presentation',
          text: '若手理論交流研究会〜物性研究における最近の進展 において口頭発表を行いました．'
        },
        {
          date: '2023年11月28日',
          type: 'publication',
          text: 'κ系有機化合物中の反強磁性誘起FFLO超伝導に関する論文がPhys. Rev. Researchで<a href="https://journals.aps.org/prresearch/abstract/10.1103/PhysRevResearch.5.043171" target="_blank">出版</a>されました．また，本研究に関する<a href="https://www.c.u-tokyo.ac.jp/info/news/topics/20231128140000.html" target="_blank">プレスリリース</a>を配信しました．'
        },
        {
          date: '2023年10月17日',
          type: 'presentation',
          text: 'Trends in the Theory of Quantum Materials 2023において口頭発表を行いました．'
        },
        {
          date: '2023年10月3日',
          type: 'publication',
          text: 'スピン軌道相互作用によって実現する非自明なStoner磁性に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2310.00838" target="_blank">arXiv:2310.00838</a>)．'
        },
        {
          date: '2023年9月18日',
          type: 'presentation',
          text: '日本物理学会第78回年次大会において口頭発表を行いました．'
        },
        {
          date: '2023年8月29日',
          type: 'note',
          text: 'プレプリントの公開に伴い，研究で使用したプログラムおよび関連するノートを公開しました．'
        },
        {
          date: '2023年8月29日',
          type: 'publication',
          text: 'κ系有機化合物中の反強磁性誘起FFLO超伝導に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2308.14227" target="_blank">arXiv:2308.14227</a>)．'
        },
        {
          date: '2023年7月4日',
          type: 'presentation',
          text: '<a href="https://www.sces2023.org" target="_blank">International Conference on Strongly Correlated Electron Systems 2023</a>においてポスター発表を行い，Best Poster Awardを受賞しました．'
        },
        {
          date: '2023年7月1日',
          type: 'publication',
          text: 'Dirac半金属中の結晶対称性に守られたギャップレス渦線相に関する論文がPhys. Rev. Bで<a href="https://journals.aps.org/prb/abstract/10.1103/PhysRevB.107.214518" target="_blank">出版</a>されました．'
        },
        {
          date: '2023年4月19日',
          type: 'cv',
          text: '科研費若手研究および基盤研究(C)の補助による研究課題を始めました．研究期間はそれぞれ2026年3月・2027年3月までです．'
        },
        {
          date: '2023年3月25日',
          type: 'presentation',
          text: '日本物理学会2023年春季大会において口頭発表とポスター発表を1件ずつ行いました．'
        },
        {
          date: '2023年3月7日',
          type: 'presentation',
          text: 'APS March Meeting 2023において口頭発表を行いました．'
        },
        {
          date: '2023年2月16日',
          type: 'publication',
          text: 'Dirac半金属中の結晶対称性に守られたギャップレス渦線相に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2302.07451" target="_blank">arXiv:2302.07451</a>)．'
        },
        {
          date: '2023年1月13日',
          type: 'presentation',
          text: '<a href="http://park.itc.u-tokyo.ac.jp/KMBseminar/wiki.cgi/BusseiSeminar?page=%CA%AA%C0%AD%A5%BB%A5%DF%A5%CA%A1%BC%2F2023%2D1%2D13" target="_blank">駒場物性セミナー</a>において超伝導ノードの分類に関する発表を行いました．'
        },
        {
          date: '2022年11月17日',
          type: 'presentation',
          text: '<a href="https://www2.yukawa.kyoto-u.ac.jp/~nqs2022/" target="_blank">Novel Quantum States in Condensed Matter 2022</a>において口頭発表を行いました．'
        },
        {
          date: '2022年9月1日',
          type: 'etc',
          text: '東京大学大学院総合文化研究科に異動しました．'
        },
        {
          date: '2022年8月23日',
          type: 'presentation',
          text: '<a href="https://www.lt29.jp" target="_blank">29th International Conference on Low Temperature Physics</a>においてポスター発表を行いました．'
        },
        {
          date: '2022年8月1日',
          type: 'publication',
          text: '超伝導電流誘起Weyl超伝導に関する論文がJPS Hot Topicsの<a href="https://doi.org/10.7566/JPSHT.2.028" target="_blank">オンライン記事</a>で紹介されました．'
        },
        {
          date: '2022年7月13日',
          type: 'publication',
          text: '超伝導電流誘起トポロジカル相転移に関する論文がPhys. Rev. Bで<a href="https://journals.aps.org/prb/abstract/10.1103/PhysRevB.106.014508" target="_blank">出版</a>されました．'
        },
        {
          date: '2022年6月3日',
          type: 'publication',
          text: '超伝導電流誘起Weyl超伝導に関する論文がJ. Phys. Soc. Jpn.で<a href="https://journals.jps.jp/doi/abs/10.7566/JPSJ.91.074703" target="_blank">出版</a>されました．'
        },
        {
          date: '2022年5月10日',
          type: 'note',
          text: '研究で使用したいくつかのプログラムを公開しました．'
        },
        {
          date: '2022年3月15日',
          type: 'presentation',
          text: '日本物理学会第77回年次大会において発表を行いました．'
        },
        {
          date: '2022年2月25日',
          type: 'presentation',
          text: '2/22, 24, 25の3日間，<a href="https://www.ms.u-tokyo.ac.jp/~yasuyuki/crest2022.htm" target="_blank">CRESTチュートリアル・ワークショップ「物質のトポロジカル相の理論的探究」</a>において講演を行いました．'
        },
        {
          date: '2022年1月20日',
          type: 'publication',
          text: '超伝導電流誘起Weyl超伝導に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2201.07397" target="_blank">arXiv:2201.07397</a>)．'
        },
        {
          date: '2022年1月13日',
          type: 'publication',
          text: 'LaNiGa<sub>2</sub>に関する論文がCommun. Phys.で<a href="https://www.nature.com/articles/s42005-021-00771-5" target="_blank">出版</a>されました．'
        },
        {
          date: '2021年12月28日',
          type: 'publication',
          text: '超伝導ギャップ構造の分類理論に関するレビュー論文がJPS Hot Topicsの<a href="https://doi.org/10.7566/JPSHT.1.068" target="_blank">オンライン記事</a>で紹介されました．'
        },
        {
          date: '2021年12月24日',
          type: 'presentation',
          text: '基研研究会「非自明な電子状態が生み出す超伝導現象の最前線：新たな挑戦と展望」にてポスター発表および口頭発表を行いました．'
        },
        {
          date: '2021年11月30日',
          type: 'publication',
          text: 'トポロジカルSNS接合系に関する論文がPhys. Rev. Bで<a href="https://journals.aps.org/prb/abstract/10.1103/PhysRevB.104.205431" target="_blank">出版</a>されました．'
        },
        {
          date: '2021年11月10日',
          type: 'publication',
          text: '超伝導ギャップ構造の分類理論に関するレビュー論文がオンライン上で<a href="https://doi.org/10.1093/ptep/ptab124" target="_blank">出版</a>され，Editor\'s Choiceに選出されました．'
        },
        {
          date: '2021年10月15日',
          type: 'publication',
          text: '超伝導電流誘起トポロジカル相転移に関する研究のプレプリントが公開されました(<a href="https://arxiv.org/abs/2110.06959" target="_blank">arXiv:2110.06959</a>)．'
        },
        {
          date: '2021年10月5日',
          type: 'presentation',
          text: '名古屋大学で招待セミナー(オンライン)を行いました．'
        },
        {
          date: '2021年9月20日',
          type: 'presentation',
          text: '日本物理学会2021年秋季大会において発表を行いました．'
        },
        {
          date: '2021年9月16日',
          type: 'publication',
          text: 'LaNiGa<sub>2</sub>に関する研究のプレプリントが公開されました(<a href="https://arxiv.org/abs/2109.06983" target="_blank">arXiv:2109.06983</a>)．'
        },
        {
          date: '2021年9月8日',
          type: 'publication',
          text: 'トポロジカルSNS接合系に関する研究のプレプリントを公開しました(<a href="https://arxiv.org/abs/2109.02918" target="_blank">arXiv:2109.02918</a>)．'
        },
        {
          date: '2021年7月14日',
          type: 'publication',
          text: '超伝導ギャップ構造の分類理論に関するレビュー論文のプレプリントを公開しました(<a href="https://arxiv.org/abs/2107.05801" target="_blank">arXiv:2107.05801</a>)．'
        },
        {
          date: '2021年3月15日',
          type: 'presentation',
          text: '日本物理学会第76回年次大会において発表を行いました．'
        },
        {
          date: '2021年1月22日',
          type: 'presentation',
          text: 'カリフォルニア大学デービス校で招待セミナー(オンライン)を行いました．'
        },
        {
          date: '2020年12月17日',
          type: 'publication',
          text: '学位論文が"Springer Theses"として出版されました．'
        },
        {
          date: '2020年11月18日',
          type: 'publication',
          text: '雑誌「固体物理」で奇パリティ多極子相の研究に関する解説記事が出版されました．'
        },
        {
          date: '2020年10月19日',
          type: 'publication',
          text: '雑誌「固体物理」で超伝導ギャップ構造の分類理論に関する解説記事が出版されました．'
        },
        {
          date: '2020年9月30日',
          type: 'presentation',
          text: 'Tohoku University - RIKEN Joint Workshop --- Math meets Quantum Materials ---において招待講演を行いました．'
        },
        {
          date: '2020年9月11日',
          type: 'presentation',
          text: '日本物理学会2020年秋季大会において発表を行いました．'
        },
        {
          date: '2020年8月12日',
          type: 'publication',
          text: '波数基底の多極子揺らぎ媒介超伝導に関する論文が<a href="https://journals.aps.org/prresearch/abstract/10.1103/PhysRevResearch.2.033225" target="_blank">出版</a>されました．'
        },
        {
          date: '2020年7月21日',
          type: 'publication',
          text: '波数基底の多極子揺らぎ媒介超伝導に関する論文がPhys. Rev. Research誌にアクセプトされました．'
        },
        {
          date: '2020年5月7日',
          type: 'etc',
          text: 'ウェブサイトを一新しました．'
        }
      ] as NewsInfo[]
    }
  }
})
